import { useQuery } from "@tanstack/react-query";
import { activityApi } from "../api/activityApi";

export function useRecentActivity(limit = 10) {
  return useQuery({
    queryKey: ["activity", limit],
    queryFn: () => activityApi.getRecentActivity(limit),
  });
}

export function useActivityStats() {
  return useQuery({
    queryKey: ["activity-stats"],
    queryFn: activityApi.getStats,
  });
}
